var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.5H16.5V21H7.5V16.5ZM18.3 19.2V14.7H5.7V19.2H3.9C3.66131 19.2 3.43239 19.1052 3.2636 18.9364C3.09482 18.7676 3 18.5387 3 18.3V9.3C3 9.06131 3.09482 8.83239 3.2636 8.6636C3.43239 8.49482 3.66131 8.4 3.9 8.4H20.1C20.3387 8.4 20.5676 8.49482 20.7364 8.6636C20.9052 8.83239 21 9.06131 21 9.3V18.3C21 18.5387 20.9052 18.7676 20.7364 18.9364C20.5676 19.1052 20.3387 19.2 20.1 19.2H18.3ZM5.7 10.2V12H8.4V10.2H5.7ZM7.5 3H16.5C16.7387 3 16.9676 3.09482 17.1364 3.2636C17.3052 3.43239 17.4 3.66131 17.4 3.9V6.6H6.6V3.9C6.6 3.66131 6.69482 3.43239 6.8636 3.2636C7.03239 3.09482 7.2613 3 7.5 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer-icon.c4ee19c704c6d0240634707651862d61.svg";
export { ForwardRef as ReactComponent };